module.exports = __webpack_public_path__ + "static/media/bg_plan_suggestion_from_30_to_34.2b948954.webp";